import { Component } from '@angular/core';
import { LanguageService } from './shared/language.service';
import { AppUpdateService } from './shared/services';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  constructor(languageService: LanguageService, appUpdateService: AppUpdateService) {
    languageService.register();
    appUpdateService.init();
  }
}
